const NEXT_IMAGE_WIDTHS = [16, 32, 48, 64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840]

const getSupportedWidth = requestedWidth => {
  const width = Number(requestedWidth)

  if (!Number.isFinite(width) || width <= 0) {
    return null
  }

  return NEXT_IMAGE_WIDTHS.find(supportedWidth => supportedWidth >= width) || 3840
}

export const getOptimizedImageUrl = (src, requestedWidth, quality = 75) => {
  const width = getSupportedWidth(requestedWidth)

  if (!src || !width || !/^https?:\/\//i.test(src)) {
    return src
  }

  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`
}
